module.exports = __webpack_public_path__ + "img/input_B_bg_error.013895b7.png";